<template>
  <modal
    :show="showAddTeamMemberModal"
    @close="close()"
  >
    <form @submit.prevent="addTeamMember">
      <div class="w-full h-full p-6 space-y-6">
        <div class="w-full flex justify-between">
          <h2 class="text-xl">
            Invite Team Member
          </h2>
          <span
            class="text-gray-300 hover:text-gray-900 cursor-pointer"
            @click="showAddTeamMemberModal = false"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </span>
        </div>
        <div class="col-span-6">
          <div class="max-w-xl text-sm text-gray-600">
            Please provide the email address of the person you would like to add to this team.
          </div>
        </div>

        <!-- Member Email -->
        <div class="col-span-6 sm:col-span-4">
          <jet-label
            for="email"
            value="Email"
          />
          <jet-input
            id="email"
            v-model="addTeamMemberForm.email"
            type="email"
            class="mt-1 block w-full"
          />
          <jet-input-error
            :message="addTeamMemberForm.errors.email"
            class="mt-2"
          />
        </div>

        <!-- Role -->
        <div
          v-if="availableRoles.length > 0"
          class="col-span-6 lg:col-span-4"
        >
          <jet-label
            for="roles"
            value="Role"
          />
          <jet-input-error
            :message="addTeamMemberForm.errors.role"
            class="mt-2"
          />

          <div class="relative z-0 mt-1 border border-gray-200 rounded-lg cursor-pointer">
            <button
              v-for="(role, i) in availableRoles"
              :key="role"
              type="button"
              class="relative px-4 py-3 inline-flex w-full rounded-lg focus:z-10 focus:outline-none focus:border-blue-300 focus:ring focus:ring-blue-200"
              :class="{'border-t border-gray-200 rounded-t-none': i > 0, 'rounded-b-none': i != Object.keys(availableRoles).length - 1}"
              @click="addTeamMemberForm.role = role"
            >
              <div :class="{'opacity-50': addTeamMemberForm.role && addTeamMemberForm.role != role}">
                <!-- Role Name -->
                <div class="flex items-center">
                  <div
                    class="text-sm text-gray-600 capitalize"
                    :class="{'font-semibold': addTeamMemberForm.role == role}"
                  >
                    {{ role }}
                  </div>

                  <svg
                    v-if="addTeamMemberForm.role == role"
                    class="ml-2 h-5 w-5 text-green-400"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  ><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                </div>
              </div>
            </button>
          </div>
        </div>
        <div class="flex justify-between">
          <button
            class="bg-green-400 w-2/5 py-2 rounded-lg"
            type="submit"
            @click="addTeamMember"
          >
            Send invite
          </button>
          <button
            class="bg-gray-300 w-2/5 py-2 rounded-lg"
            @click="close()"
          >
            Cancel
          </button>
        </div>
      </div>
    </form>
  </modal>
</template>

<script>
import JetInput from '../../Jetstream/Input.vue';
import JetInputError from '../../Jetstream/InputError.vue';
import JetLabel from '../../Jetstream/Label.vue';
import Modal from '../../Jetstream/Modal.vue';

export default {
  components: {
    Modal,
    JetInput,
    JetInputError,
    JetLabel,
  },

  props: [
    'team',
    'availableRoles',
    'defaultPermissions',
    'permissions',
  ],
  data() {
    return {
      addTeamMemberForm: this.$inertia.form({
        email: '',
        role: null,
      }),
    };
  },
  methods: {
    close() {
      this.$emit('close');
      this.form.reset();
    },
    addTeamMember() {
      this.addTeamMemberForm.post(route('team-members.store', this.team), {
        errorBag: 'addTeamMember',
        preserveScroll: true,
        onSuccess: () => {
          this.addTeamMemberForm.reset();
          this.showAddTeamMemberModal = false;
        },
      });
    },

    manageRole(teamMember) {
      this.managingRoleFor = teamMember;
      this.updateRoleForm.role = teamMember.membership.role;
      this.currentlyManagingRole = true;
    },

    updateRole() {
      this.updateRoleForm.put(route('team-members.update', [this.team, this.managingRoleFor]), {
        preserveScroll: true,
        onSuccess: () => (this.currentlyManagingRole = false),
      });
    },

    displayableRole(role) {
      return this.availableRoles.find((r) => r.key === role).name;
    },
  },
};
</script>
